module.exports = __webpack_public_path__ + "static/media/PF-1032Rejilla.1afb2bc2.jpg";